<template>
  <b-form @submit.prevent="onSubmitHandler" class="font_Montserrat mt-3">
    <p>
      Phairify alerts you to job opportunity matches as they are posted. Alerts
      are posted automatically to your Dashboard.
    </p>
    <p>
      If you would like to receive alerts by e-mail or texts, please provide an e-mail
      address and/or a phone number. Select ‘Disable Alerts’ to turn off alerts.
    </p>
    <b-row class="mt-4">
      <b-col md="4">
        <b-form-group
          label="Email:"
          label-class="font_size_1000rem text-uppercase v3_color_teal"
          invalid-feedback="Please enter a valid Email address."
          :state="validateState('email')"
        >
          <b-form-input class="rounded_0 border_black_knight" placeholder="Enter Email" v-model="$v.email.$model" type="text" />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          label="Phone Number:"
          label-class="font_size_1000rem text-uppercase v3_color_teal"
          invalid-feedback="The Phone Number must be like XXX-XXX-XXXX."
          :state="validateState('phoneNumber')"
        >
          <b-form-input class="rounded_0 border_black_knight" placeholder="Enter Number" v-model="$v.phoneNumber.$model" type="text" />
        </b-form-group>
      </b-col>
      <b-col md="4" class="border_left_1 d-flex align-items-center">
        <b-form-group
          label="Disable Alerts:"
          label-cols="8"
          label-class="font_size_1000rem text-uppercase v3_color_teal"
          class="w-100 m-0"
        >
          <b-form-checkbox
            class="v2_control_checkbox d-flex align-items-center mt-2"
            v-model="disableAlerts"
            :value="1"
            :unchecked-value="0"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col cols="12" class="d-flex align-items-center justify-content-start mobile-version">
        <b-button variant="v3_red_outline" @click="$emit('cancel')">Cancel</b-button>
        <b-button variant="v3_teal_outline" type="submit" class="ml-4">
          Save Preferences
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { email, helpers } from 'vuelidate/lib/validators';
import validateStateMixin from '@/mixins/validateStateMixin';
import { PHONE_VALIDATION_RGEXP } from '@/helpers/PhoneHelpers';
const phone = helpers.regex('phone', PHONE_VALIDATION_RGEXP);

export default {
  name: 'IcoAlertsForm',
  mixins: [validationMixin, validateStateMixin],
  data: function () {
    return {
      email: null,
      phoneNumber: null,
      disableAlerts: 0,
    };
  },
  validations: {
    email: { email },
    phoneNumber: { phone },
  },
  created: function () {
    const data = localStorage.getItem(this.localStorageKey);
    if (!data) return;
    try {
      const {
        email = null,
        phoneNumber = null,
        disableAlerts = 0,
      } = JSON.parse(data);
      this.email = email;
      this.phoneNumber = phoneNumber;
      this.disableAlerts = disableAlerts;
    } catch (e) {
      return;
    }
  },
  computed: {
    localStorageKey: function () {
      const { email = '' } = this.$store.state.user;
      return `${email}_ico_alerts`;
    },
  },
  methods: {
    onSubmitHandler: function () {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      localStorage.setItem(
        this.localStorageKey,
        JSON.stringify({
          email: this.email,
          phoneNumber: this.phoneNumber,
          disableAlerts: this.disableAlerts,
        })
      );
      this.$emit('saved');
    },
  },
};
</script>

<style scoped></style>
